import { colors, Skeleton, styled, TableCell, TableRow } from "@mui/material";
import { tableCellClasses } from '@mui/material/TableCell';
import { tableRowClasses } from '@mui/material/TableRow';
import { useEffect, useRef, useState } from "react";
import { alpha } from "@mui/material/styles";

const TableCellText = ({ content, isLoading = false, bgColor = colors.grey[100], colSpan = 1, rowSpan = 1, style = {}, isSelected}) => {


  // const StyledTableCell = styled(TableCell)(({ theme }) => ({
  //   [`&.${tableCellClasses.body}`]: {
  //     border: '2px solid #fff',
  //     backgroundColor: bgColor,
  //   },
  // }));

  const styleObj = {
    border: '2px solid #fff',
    background: bgColor,
    ...style
  };

  const sxObj = {
    position: "relative",
    "&::after": isSelected
      ? {
          content: '""',
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          bgcolor: "#2196f3",
          opacity: 0.5,
          pointerEvents: "none",
        }
      : {},
  };

  return isLoading ? <TableCell style={styleObj} sx={sxObj} colSpan={colSpan} rowSpan={rowSpan}><Skeleton variant="rounded" width={100} height={20} /></TableCell>
    : <TableCell style={styleObj} sx={sxObj} colSpan={colSpan} rowSpan={rowSpan}>{content}</TableCell>;
};

export default TableCellText;